'use es6';

import { useState } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'foundations-components/components/Flex';
import { useHideDialog } from 'reporting-action-components/dialog/ducks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Table } from 'foundations-components/transitional/components/Table';
import { Tabs, Tab } from 'foundations-components/transitional/components/TabsTransitionalOld';
import ScheduledEmailRow from './ScheduledEmailRow';
import EmailHelpText from '../../shared/EmailHelpText';
import { requiredReportOrDashboardPropCheck } from '../../shared/sharedPropValidation';
import { SHARE_EMAIL, SHARE_SLACK } from '../../shareAsset/shareTypes';
import { useCreateAndOwnUsers } from '../../../data/hooks/useCreateAndOwnUsers';
import { useRecurringShareAssets } from '../../../data/hooks/useRecurringShareAssets';
import { useGetThirdPartyApps } from '../../../data/hooks/useGetThirdPartyApps';
import { REPORT_OBJECT_TYPE } from 'dashboard-lib/public/emails/emails';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScheduleTable = ({
  appUsageTracker,
  createAndOwnUsers,
  createAndOwnUsersLabels,
  report,
  dashboard,
  recurringAssets,
  onEditSuccess,
  objectId,
  objectType,
  assetSpecificTrackingProps,
  currentDialog
}) => {
  const displayDataExport = currentDialog === SHARE_EMAIL;
  return /*#__PURE__*/_jsxs(Table, {
    minInlineSize: "1000px",
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [currentDialog !== SHARE_EMAIL && /*#__PURE__*/_jsx("col", {
        style: {
          width: '15%'
        }
      }), /*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {
        style: {
          width: '15%'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '15%'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '20%'
        }
      }), displayDataExport && /*#__PURE__*/_jsx("col", {
        style: {
          width: '10%'
        }
      })]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [currentDialog !== SHARE_EMAIL && /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.appNameLabel"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: currentDialog === SHARE_EMAIL ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.emailNicknameLabel"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.nicknameLabel"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'reporting-action-components.actions.manageRecurringEmails.dialog.table.timeOfDayLabel'
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'reporting-action-components.actions.manageRecurringEmails.dialog.table.scheduleLabel'
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.ownerLabel"
          })
        }), displayDataExport && /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.downloadableFile"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: recurringAssets.length === 0 ? /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: "5",
          children: /*#__PURE__*/_jsx(Flex, {
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.emptyMessage"
            })
          })
        })
      }, "empty") : recurringAssets.map(schedule => /*#__PURE__*/_jsx(ScheduledEmailRow, {
        appUsageTracker: appUsageTracker,
        report: report,
        dashboard: dashboard,
        schedule: schedule,
        createAndOwnUsers: createAndOwnUsers,
        createAndOwnUsersLabels: createAndOwnUsersLabels,
        onEditSuccess: onEditSuccess,
        objectId: objectId,
        objectType: objectType,
        assetSpecificTrackingProps: assetSpecificTrackingProps,
        currentDialog: currentDialog
      }, `email-${schedule.id}`))
    })]
  });
};
const ShareTabNavigation = (currentDialog, setCurrentDialog) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "300",
    children: /*#__PURE__*/_jsxs(Tabs, {
      selected: currentDialog,
      onSelectedChange: nextTabId => {
        setCurrentDialog(nextTabId);
      },
      children: [/*#__PURE__*/_jsx(Tab, {
        icon: "email",
        tabId: SHARE_EMAIL,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.emailReport.dialog.title"
        })
      }), /*#__PURE__*/_jsx(Tab, {
        icon: "integrations",
        tabId: SHARE_SLACK,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.otherAppsReport.dialog.title"
        })
      })]
    })
  });
};
const assetSpecificTrackingPropsPropDefault = {};
const getEnabledThirdPartyRecurringAssets = (recurringAssets, thirdPartyApps = []) => {
  return recurringAssets.filter(scheduledItem => {
    try {
      var _JSON$parse;
      const appId = (_JSON$parse = JSON.parse(scheduledItem.recipientDestination)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.appId;
      if (!appId) {
        return false;
      }
      const thirdPartyApp = thirdPartyApps.find(thirdPartyAppItem => thirdPartyAppItem.id === appId);
      const isThirdPartyAppDisconnected = thirdPartyApp && !!thirdPartyApp.connectionStatusTranslatedErrorMessage;
      return !isThirdPartyAppDisconnected;
    } catch (error) {
      console.error(error);
      return false;
    }
  });
};
const ManageRecurringShareAssetsDialog = ({
  appUsageTracker,
  report,
  dashboard,
  objectId,
  objectType,
  assetSpecificTrackingProps = assetSpecificTrackingPropsPropDefault
}) => {
  const [currentDialog, setCurrentDialog] = useState(SHARE_EMAIL);
  const hideDialog = useHideDialog();
  const {
    data: createAndOwnUsersData,
    loading: createAndOwnUsersLoading
  } = useCreateAndOwnUsers();
  const {
    data: recurringAssets = [],
    loading: recurringAssetsLoading,
    refetch: refetchRecurringAssets
  } = useRecurringShareAssets({
    objectId,
    objectType,
    deliveryType: currentDialog
  });
  const {
    data: thirdPartyApps,
    loading: thirdPartyAppsLoading
  } = useGetThirdPartyApps();
  const isThirdPartyShareTab = currentDialog === SHARE_SLACK;
  const filteredRecurringAssets = isThirdPartyShareTab ? getEnabledThirdPartyRecurringAssets(recurringAssets, thirdPartyApps) : recurringAssets;

  // Do not display the "Other Apps" on the Dashboards Shares
  const displayThirdPartyApp = objectType === REPORT_OBJECT_TYPE;
  return /*#__PURE__*/_jsxs(Modal, {
    onEsc: () => {
      hideDialog();
    },
    width: 1200,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => {
          hideDialog();
        }
      }), /*#__PURE__*/_jsx(H2, {
        margin: "0",
        children: displayThirdPartyApp ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringAssets.dialog.title"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.title"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      paddingBlockStart: "1000",
      children: [displayThirdPartyApp && ShareTabNavigation(currentDialog, setCurrentDialog), createAndOwnUsersLoading || recurringAssetsLoading || thirdPartyAppsLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered"
      }) : /*#__PURE__*/_jsx(ScheduleTable, {
        appUsageTracker: appUsageTracker,
        createAndOwnUsers: createAndOwnUsersData.get('createAndOwnUsers'),
        createAndOwnUsersLabels: createAndOwnUsersData.get('createAndOwnUsersLabels').toJS(),
        report: report,
        dashboard: dashboard,
        recurringAssets: filteredRecurringAssets,
        onEditSuccess: () => refetchRecurringAssets(),
        objectId: objectId,
        objectType: objectType,
        assetSpecificTrackingProps: assetSpecificTrackingProps,
        currentDialog: currentDialog
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: currentDialog === SHARE_EMAIL && /*#__PURE__*/_jsx(EmailHelpText, {})
    })]
  });
};
ManageRecurringShareAssetsDialog.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  report: requiredReportOrDashboardPropCheck,
  dashboard: requiredReportOrDashboardPropCheck,
  objectId: PropTypes.number.isRequired,
  objectType: PropTypes.string.isRequired,
  assetSpecificTrackingProps: PropTypes.object
};
export default ManageRecurringShareAssetsDialog;